/**
 * Rutas de Activos
 * Gestión de activos: jerarquía, líneas de producción, estados de disponibilidad
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import JerarquiaActivos from '../pages/activos/hierachy/JerarquiaActivos.jsx'
import ProductionLineas from '../pages/activos/production-lines/ProductionLineas.jsx' 
import Products from '../pages/activos/productos/Products.jsx'
import AssetManagement from '../pages/activos/asset-registration/AssetManagement.jsx'
import EstadosDisponibilidad from '../pages/activos/availability/EstadosDisponibilidad.jsx'

export const assetsRoutes = [
  <Route 
    key="jerarquia-activos" 
    path="/jerarquia-activos" 
    element={
      <ProtectedRoute>
        <JerarquiaActivos />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="lineas" 
    path="/lineas" 
    element={
      <ProtectedRoute>
        <ProductionLineas />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="products" 
    path="/products" 
    element={
      <ProtectedRoute>
        <Products />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="asset-management" 
    path="/asset-management" 
    element={
      <ProtectedRoute>
        <AssetManagement />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="estados-disponibilidad" 
    path="/estados-disponibilidad" 
    element={
      <ProtectedRoute>
        <EstadosDisponibilidad />
      </ProtectedRoute>
    } 
  />,
]